import $ from "jquery";
import "slick-carousel";
import "./libs/riddle";
import formBuilder from "eloqua-form-renderer";
import initializeSubscribeModal from "./components/subscribe-modal";
import "./search";
import "@patternlab/source/js/index";

window.$ = window.jQuery = $;

require("./bootstrap");

initializeSubscribeModal();

$(function () {
    $(".carousel-slider").each(function () {
        $(this).slick({
            centerMode: true,
            lazyLoad: "ondemand",
            swipe: true,
            swipeToSlide: true,
            slidesToShow: 1,
            centerPadding: "140px",
            dots: true,
            prevArrow:
                "<button type='button' class='slick-arrow slick-prev pull-left' style='z-index:1;'><div class='arrow'></div></button>",
            nextArrow:
                "<button type='button' class='slick-arrow slick-next pull-right' style='z-index:1;'><div class='arrow'></div></button>",
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        centerMode: false,
                        slidesToShow: 1,
                        centerPadding: "30px",
                    },
                },
                {
                    breakpoint: 700,
                    settings: {
                        dots: true,
                        centerMode: true,
                        slidesToShow: 1,
                        centerPadding: "0px",
                    },
                },
            ],
        });
    });
});

formBuilder();
